import React from "react";
import { colors } from "../../constants/colors";
import appStoreBadge from "../../images/appStoreBadge.svg";
import slider1 from "../../images/slider1.jpg";
import slider2 from "../../images/slider2.jpg";
import slider3 from "../../images/silder3.jpg";
import Slider from "react-slick";

const settings = {
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  centerMode: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        centerMode: true,
        variableWidth: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        centerMode: true,
        variableWidth: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        centerMode: true,
        variableWidth: true,
      }
    }
  ]
};
export const Circles = () => {


  return (
    <section data-aos="flip-up" className="circles-app container-fluid cotactUs" id="circles-app">
      <div className="row">
        <div className="col-sm-12 col-md-5 p-5">
          <div className="howItWork-circle">
            <h1
              className="text-center text-md-left"
              style={{ color: colors.gencBlue }}
            >
              Circles App
          </h1>
            <p stlye={{ color: colors.gencBlack }}>
              Connect with your family and your community while improving your
              health and wellness. Use the app to monitor your sleep, steps,
              stress, allergies, store/access medical history, mental state, keep
              a journal, ask questions to figureheads/specialists in your
              community, keep an eye on your close family’s health and well being.
              For an added price, get your own Health Report Cards Define Health
              Report Card as: A weekly, biweekly, or monthly report card that can
              give you a more detailed look into your health
          </p>
            <div style={{ marginTop: '40px' }}>
              <img src={appStoreBadge} alt="App Store Badge" />
            </div>
          </div>
        </div>

        <div className="circles-app-images p-5    col-sm-12 col-md-7">
          <Slider {...settings}>
            <div>
              <img src={slider1} alt="App Store Badge" />
            </div>
            <div>
              <img src={slider2} alt="App Store Badge" />
            </div>
            <div>
              <img src={slider3} alt="App Store Badge" />
            </div>

          </Slider>
        </div>
      </div>

    </section>
  );
};
